import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<string | undefined> = (src) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '60vh',
  textAlign: 'center',
  position: 'relative',
  width: (p) => p.spacing(62),
  gap: (p) => p.spacing(4),

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${src})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    zIndex: -1,
  },
});

export const content: SxStyle = {
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(/assets/icons/fingerprint.svg)`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    opacity: 0.1,
    zIndex: -1,
  },
};
